import { DEFAULT_PREFERENCES } from '../constants/options';

export function createSeed() {
  return {
    preferences: { ...DEFAULT_PREFERENCES },
    dayOffset: 0,
    days: {},
    recurring: [],
    pages: [
      {
        id: 'page-someday',
        name: 'Someday',
        lists: [{ id: 'list-todo', title: 'Todo', tasks: [] }],
      },
    ],
    activePageId: 'page-someday',
    listsExpanded: true,
    listsHeight: 300,
    profile: { name: 'You', waitlist: false },
    undo: null,
  };
}
